import Box from "@mui/material/Box";
import BreadCrumb from "app/components/BreadCrumb";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";

import ActionBar from "./components/ActionBar";
import AddCustomerModal from "./components/AddCustomerModal";
import CustomersTable from "./components/CustomersTable";
import {
  selectCustomersList,
  selectCustomersLoading,
} from "./redux/selector";
import { customersActions, reducer, sliceKey } from "./redux/slice";
import { customersSaga } from "./redux/saga";
import { useStyles } from "./styles";

const Customers = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  useInjectReducer({
    key: sliceKey,
    reducer,
  });

  useInjectSaga({
    key: sliceKey,
    saga: customersSaga,
  });

  const rows = useSelector(selectCustomersList);
  const loading = useSelector(selectCustomersLoading);

  useEffect(() => {
    dispatch(customersActions.getCustomersList());
  }, [dispatch]);

  return (
    <Box className={styles.container}>
        <Box className={styles.scrollContent} dir={i18n.dir()}>
          <Box className={styles.pageContent}>
            <BreadCrumb title={t("CUSTOMERS.TITLE")} iconPosition="end" />
            <ActionBar />
            <CustomersTable rows={rows} loading={loading} />
          </Box>
        </Box>
      <AddCustomerModal />
    </Box>
  );
};

export default Customers;
